<template>
  <div>
    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-title>
          <template v-slot:default="{ expanded }">
            <v-row no-gutters>
              <v-col cols="12"> {{ $t('History') }} ( {{ history ? history.length : 0 }} )</v-col>
            </v-row>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-data-table
            :headers="taskHistoryHeaders"
            :items="history"
            class="elevation-1"
            disable-sort
            dense
            :footer-props="pagination"
            hide-default-footer
          >
            <template v-slot:item="props">
              <tr class="taskHistory">
                <td class="statusCell">{{ (props.item.task.status || {}).name }}</td>
                <td class="commentCell">
                  <pre style="white-space: pre-wrap;">{{ props.item.task.comment }}</pre>
                </td>
                <td class="userCell">{{ props.item.task.assignedTo ? props.item.task.assignedTo.displayName : '' }}</td>
                <td class="userCell">{{ props.item.task.completedBy ? props.item.task.completedBy.displayName : '' }}</td>
                <td class="userCell">{{ props.item.task.modifiedBy ? props.item.task.modifiedBy.displayName : '' }}</td>
                <td class="dateCell">{{ $filters.DateTimeFilter(props.item.task.modifiedByDate) }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'TaskHistory',
  data() {
    return {
      pagination: {
        'items-per-page-options': [100]
      },
      taskHistoryHeaders: [
        {
          title: this.$t('Status'),
          key: 'status'
        },
        {
          title: this.$t('Comment'),
          key: 'comment'
        },
        {
          title: this.$t('Assigned_To'),
          key: 'assignee'
        },
        {
          title: this.$t('Completed_By'),
          key: 'completedBy'
        },
        {
          title: this.$t('Modified_By'),
          key: 'modifiedBy'
        },
        {
          title: this.$t('Date'),
          key: 'date'
        }
      ]
    }
  },
  props: {
    history: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
pre {
  font-family: 'Roboto mono', monospace;
}
.taskHistory {
  background-color: rgb(236, 236, 241);
}
.userCell {
  vertical-align: top;
  min-width: 200px;
  max-width: 200px;
}
.statusCell {
  vertical-align: top;
  min-width: 200px;
  max-width: 200px;
}
.dateCell {
  vertical-align: top;
  min-width: 200px;
  max-width: 200px;
}
.commentCell {
  vertical-align: top;
  width: 100%;
}
.theme--dark .taskHistory {
  background-color: rgb(54, 54, 56);
}
</style>
